<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 76 71"
        fill="none"
        width="76"
        height="71"
        class="ml-5 inline-block size-9 md:size-10 lg:size-16 xl:size-[4.5rem]">
        <g opacity="0.5">
            <path
                d="M56.7888 20.9279C56.7888 31.0652 48.4173 39.3557 38.0001 39.3557C27.5829 39.3557 19.2114 31.0652 19.2114 20.9279C19.2114 10.7905 27.5829 2.5 38.0001 2.5C48.4173 2.5 56.7888 10.7905 56.7888 20.9279Z"
                stroke="url(#paint0_linear_1105_6702)"
                stroke-width="5" />
            <path
                d="M3 69.9998C3 69.9998 10.3684 41.8555 38 41.8555C65.6316 41.8555 73.0001 69.9998 73.0001 69.9998"
                stroke="url(#paint1_linear_1105_6702)"
                stroke-width="5" />
        </g>
        <defs>
            <linearGradient
                id="paint0_linear_1105_6702"
                x1="38.0001"
                y1="0"
                x2="38.0001"
                y2="41.8557"
                gradientUnits="userSpaceOnUse">
                <stop stop-color="white" />
                <stop
                    offset="1"
                    stop-color="white"
                    stop-opacity="0" />
            </linearGradient>
            <linearGradient
                id="paint1_linear_1105_6702"
                x1="38"
                y1="41.8555"
                x2="38"
                y2="69.9998"
                gradientUnits="userSpaceOnUse">
                <stop stop-color="white" />
                <stop
                    offset="1"
                    stop-color="white"
                    stop-opacity="0" />
            </linearGradient>
        </defs>
    </svg>
</template>

<script setup lang="ts"></script>
